import React from "react";
import { CheckIcon } from "lucide-react";
type CheckListProps = {
  items: string[];
  tone?: "light" | "dark";
  columns?: boolean;
};
export function CheckList({
  items,
  tone = "light",
  columns = false
}: CheckListProps) {
  const dark = tone === "dark";
  return <ul className={`grid gap-3 ${columns ? "sm:grid-cols-2 sm:gap-x-6" : ""}`} data-id="element-19" data-mp="38no22i6lwa9w">
      {items.map(item => <li key={item} className="flex items-start gap-3" data-id="element-20" data-mp="33ob534m0tmtl">
          <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cta" data-id="element-21" data-mp="33pw0ewg5t9si">
            <CheckIcon className="h-4 w-4 text-white" strokeWidth={3} aria-hidden="true" data-id="element-22" data-mp="2yvrpy37oqjmo" />
          </span>
          <span className={`text-base font-medium leading-snug ${dark ? "text-white" : "text-ink"}`} data-id="element-23" data-mp="2twf51o0djmmq">{item}</span>
        </li>)}
    </ul>;
}